import { render, staticRenderFns } from "./SliderMainArticle.vue?vue&type=template&id=a92555be&"
import script from "./SliderMainArticle.vue?vue&type=script&lang=js&"
export * from "./SliderMainArticle.vue?vue&type=script&lang=js&"
import style0 from "./SliderMainArticle.vue?vue&type=style&index=0&id=a92555be&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports